export const getHash = (pathMatch: string) => {
  const arr = pathMatch.split('/')
  return arr[0]
}
